export default __webpack_public_path__ + "static/media/section01.443e60b1.jpg";